import {Controller} from "@stubhub/react-store-provider";
import {createSelector} from "reselect";

const loginSelector = createSelector((state, props) =>
  state.login || /* istanbul ignore next*/{}, (login) => login.loginType
);

const controller = new Controller({
  namespace: "SELL_ROUTES",
  reducers: [""],
  mapStateToProps: function (state) {
    return {
      loginType: loginSelector(state)
    };
  },
  actionCreators: {}
});

export default controller;
